import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useAuth } from '@/hooks/useAuth';
import { ShieldX, LogOut } from 'lucide-react';

const AccessDenied = () => {
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
            <ShieldX className="h-6 w-6 text-destructive" />
          </div>
          <CardTitle className="text-xl font-semibold text-destructive">
            Truy cập bị từ chối
          </CardTitle>
          <CardDescription>
            Tài khoản của bạn chưa được cấp quyền truy cập vào hệ thống
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert className="border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950">
            <AlertDescription className="text-amber-800 dark:text-amber-200">
              <div className="space-y-2">
                <p className="font-medium">Liên hệ quản trị viên</p>
                <p className="text-sm">
                  Vui lòng liên hệ quản trị viên hệ thống để được cấp quyền truy cập.
                </p>
              </div>
            </AlertDescription>
          </Alert>
          
          <Button 
            onClick={handleSignOut}
            className="w-full"
            variant="outline"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Đăng xuất
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDenied;